import { View } from "@react-pdf/renderer";
import { useMemo } from "react";

const PdfRow = ({ children, gap = 5, style, marginBottom = 8 }) => {
  const styles = useMemo(() => {
    return {
      flexDirection: "row",
      marginBottom: marginBottom,
      // marginBottom: 10,
      // marginBottom: 14,
      // paddingLeft: 10,
      gap: gap,
      ...style,
    };
  }, [style, gap, marginBottom]);

  return <View style={styles}>{children}</View>;
};

export default PdfRow;
